// Centralized geo country constants for BoatValue
// Single source of truth for analytics and geo-blocking logic

// Countries allowed for analytics tracking (first-world recreational boating markets)
export const ALLOWED_ANALYTICS_COUNTRIES = [
  'US', 'CA', // North America
  'AU', 'NZ', // Oceania
  'GB', 'IE', // British Isles
  'DE', 'FR', 'IT', 'ES', 'PT', 'NL', 'BE', 'AT', 'CH', // Western Europe
  'SE', 'NO', 'DK', 'FI', // Nordic
  'GR', 'HR', 'SI', 'CY', 'MT', // Mediterranean
  'PL', 'CZ', // Central Europe
  'JP', 'HK', 'TW', 'KR' // Asia-Pacific developed (SG removed - blocked)
];

// Countries blocked from accessing the site
export const BLOCKED_COUNTRIES = [
  'RU', 'CN', 'KP', 'IR', // Russia, China, North Korea, Iran
  'NG', 'GH', // Nigeria, Ghana
  'PK', 'BD', 'LK', // Pakistan, Bangladesh, Sri Lanka
  'ID', 'VN', 'PH', // Indonesia, Vietnam, Philippines
  'BR', 'VE', 'CO', // Brazil, Venezuela, Colombia
  'RO', 'BG', 'UA', 'BY', // Romania, Bulgaria, Ukraine, Belarus
  'TR', 'MA', 'TN', 'EG', 'ZA', // Turkey, Morocco, Tunisia, Egypt, South Africa
  'IN', 'SG' // India, Singapore
];

// Allowed hostnames for analytics tracking
export const ALLOWED_HOSTNAMES = [
  'yachtvalues.com',
  'www.yachtvalues.com',
];

// Check if hostname is allowed.
// Strict: production yachtvalues.com only. Previews, localhost, and
// lovable.app/lovableproject.com domains are intentionally excluded so they
// never contaminate the GA4 property.
export const isHostnameAllowed = (): boolean => {
  if (typeof window === 'undefined') return false;
  return ALLOWED_HOSTNAMES.includes(window.location.hostname);
};
